import useGetLessonByTrainingQuery from '@/app/hooks/useGetLessonByTrainingQuery'
import useGetTrainingById from '@/app/hooks/useGetTrainingById'
import ButtonBack from '@/view/components/ButtonBack'
import { Spinner } from '@/view/components/ui/spinner'
import { useParams } from 'react-router-dom'
import { TrainingView } from './components/TrainingView'
import { LessonListProvider } from './providers/LessonListProvider'

export default function TraningsDetails() {
  const { id } = useParams<{ id: string }>()
  const { data, isLoading } = useGetTrainingById(id!)
  const { data: lessonResponse, isLoading: isLoadingLessons } =
    useGetLessonByTrainingQuery(id!)
  const lessons = lessonResponse?.lessons

  if (isLoading || isLoadingLessons)
    return (
      <div className="flex min-h-full w-full flex-1 flex-col">
        <Spinner />
      </div>
    )
  if (!lessons || !data) return <div>Nenhum conteúdo encontrado</div>

  return (
    <div className="flex min-h-full w-full flex-1 flex-col">
      <ButtonBack label={data?.name} />
      <LessonListProvider lessons={lessons} training={data}>
        <TrainingView />
      </LessonListProvider>
    </div>
  )
}
